import React from 'react';

const MountainIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(5.000000, 10.000000)'>
        <path d='M13,0 L9.25,5 L12.1,8.8 L10.5,10 C8.81,7.75 6,4 6,4 L0,12 L22,12 L13,0 Z' />
      </g>
    </g>
  </svg>
);

export default MountainIcon;
